import React, { useState, useEffect, lazy, Suspense } from "react";
import axios from "axios";
import CacheBuster from "react-cache-buster";
import appversion from "../../package.json";
import Footer from "./FooterNew/index";
import Header from "./Header/Header";
import Logo from "./Logo Section/Logo";
import { useHyperlink } from "../contexts/HyperlinkProvider";

import Join from "./Join/Join";
import Combined from "./CombinedCarousel/Combined";
import MediaQuery from "react-responsive";
import jsonData from "../components/ai-branding.json"; // Import the JSON file

const Body = lazy(() => import("./Body/Body"));
const BodyMobile = lazy(() => import("./Body/Bodymobile"));
const SignUpForm = lazy(() => import("./ContactUS/SignUpForm.js"));
// const PostEventVideo = lazy(() =>
//   import("./PostEventVideos/PostEventVideos")
// );
// const MobilePostEventVideo = lazy(() =>
//   import("./PostEventVideos/MobilePostEventVideo")
// );
// const PostEventMemories = lazy(() =>
//   import("./PostEventMemories/PostEventMemories")
// );
const Thankyou = lazy(() => import("./ThankYou/Thankyou.js"));
const SubscribeForEventNotifications = lazy(() =>
  import("./SubscribeNotification/SubscribeForEventNotifications.js")
);

export default function Home() {
  const appVersion = appversion.version;

  const [dominateData, setDominateData] = useState();

  const [videoToggle, setVideoToggle] = useState(false);
  const [played, setPlayed] = useState(false);
  const handleVideo = (videoToggle) => {
    setVideoToggle(!videoToggle);
    setPlayed(true);
  };

  const [links, setLinks] = useState(null); // Set initial state as null

  const [angelAiLink, setAngelAiLink] = useState("");
  const [angelComLink, setAngelComLink] = useState("");
  const [sunwestLink, setSunWestLink] = useState("");
  const [celligenceLink, setCelligenceLink] = useState("");
  const [celligenceLlcLink, setCelligenceLlcLink] = useState("");
  const [pavanLink, setPavanLink] = useState("");
  const { getHyperLink } = useHyperlink();

  useEffect(() => {
    const processContent = async () => {
      const swLink = await getHyperLink("websites", "swmc", 1);
      const aiLink = await getHyperLink("websites", "angelai", 0);
      const aiComLink = await getHyperLink("websites", "angelai", 1);
      const cellLink = await getHyperLink("websites", "celligence", 1);
      const celliLlcLink = await getHyperLink("websites", "celligence", 0);
      const pavan = await getHyperLink("profiles", "pavan", 0);
      setAngelAiLink(aiLink || "AngelAi");
      setAngelComLink(aiComLink || "AngelAi.com");
      setSunWestLink(swLink || "Sun West Mortgage Company, Inc.");
      setCelligenceLink(cellLink || "Celligence");
      setCelligenceLlcLink(celliLlcLink || "Celligence LLC");
      setPavanLink(pavan || "Pavan Agarwal");
    };
    processContent();
  }, [getHyperLink]);

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_ANGELAI_JSON}?t=${Date.now()}`);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);

  useEffect(() => {
    const fetchDominateJSON = async () => {
      await axios
        .get(`${process.env.REACT_APP_CDN_URL}dominate.json?t=${Date.now()}`)
        .then(
          (response) => {
            //console.log(response.data)
            setDominateData(response.data);
          },
          (error) => {
            console.log(error);
          }
        );
    };

    fetchDominateJSON();
  }, []);

  if (dominateData) {
    const headerData = dominateData.header;
    const joinData = dominateData.join;
    const bodyData = dominateData.body;
    const speakersData = dominateData.speakers;
    const carouselData = dominateData.carousel;

    return (
      <CacheBuster
        currentVersion={appversion.version}
        isEnabled={true} //If false, the library is disabled.
        isVerboseMode={false} //If true, the library writes verbose logs to console.
        // loadingComponent={<Loading />} //If not pass, nothing appears at the time of new version check.
        metaFileDirectory={"."} //If public assets are hosted somewhere other than root on your server.
      >
        <>
          {links ? (
            <>
              <MediaQuery minWidth={992}>
                <Suspense fallback={<div />}>
                  <Body
                    handleVideo={handleVideo}
                    videoToggle={videoToggle}
                    links={links.current}
                    angelAiLink={angelAiLink}
                    sunwestLink={sunwestLink}
                    pavanLink={pavanLink}
                    bodyData={bodyData}
                  />
                </Suspense>
              </MediaQuery>
              <MediaQuery maxWidth={991}>
                <Suspense fallback={<div />}>
                  <BodyMobile
                    handleVideo={handleVideo}
                    videoToggle={videoToggle}
                    links={links.current}
                    angelAiLink={angelAiLink}
                    sunwestLink={sunwestLink}
                    pavanLink={pavanLink}
                    bodyData={bodyData}
                  />
                </Suspense>
              </MediaQuery>

              {joinData ? (
                <div>
                  <Join joinData={joinData} links={links.current} />
                </div>
              ) : (
                ""
              )}
              <div>
                <Logo />
              </div>
              <MediaQuery maxWidth={991}>
                <Suspense fallback={<div />}>
                  <SignUpForm />
                </Suspense>
              </MediaQuery>

              {/* <MediaQuery minWidth={992}>
            <Suspense fallback={<div />}>
              <PostEventVideo handleVideo={handleVideo} videoToggle={videoToggle} />
            </Suspense>
          </MediaQuery>
          <MediaQuery maxWidth={991}>
            <Suspense fallback={<div />}>
              <MobilePostEventVideo handleVideo={handleVideo} videoToggle={videoToggle} />
            </Suspense>
          </MediaQuery>
          <Suspense fallback={<div />}>
            <PostEventMemories />
          </Suspense> */}
              <Suspense fallback={<div />}>
                <Thankyou 
                  links={links.current} 
                  angelAiLink={angelAiLink}
                  sunwestLink={sunwestLink}
                />
              </Suspense>
              <Suspense fallback={<div />}>
                <SubscribeForEventNotifications />
              </Suspense>

              {carouselData ? (
                <div>
                  <Combined carouselData={carouselData} links={links.current} sunwestLink={sunwestLink}/>
                </div>
              ) : (
                ""
              )}

              <div>
                <Footer />
              </div>
            </>
          ) : (
            <div>Loading...</div>
          )}
        </>
      </CacheBuster>
    );
  } else {
    return <></>;
  }
}
